import React, {useContext,useState,useEffect} from 'react'
import {auth,db} from '../firebase.js'

const AuthContext = React.createContext()

export function useAuth() {
    return useContext(AuthContext)
}

export default function AuthProvider({children}) {
    const [currentUser, setCurrentUser] = useState()
    const [loading, setLoading] = useState(true)

    // function signup(email, password,username) {
    //     return auth.createUserWithEmailAndPassword(email, password).then(
    //         (user)=>{
    //             db.collection("Users").doc(user.user.uid).set({
    //                 email: email,
    //                 name: username,
    //                 balance: 0,
    //                 history: [],
    //             })
    //         }              
    //     )
    // }

    const login=(user)=> {
        // return auth.signInWithEmailAndPassword(email, password)
        setCurrentUser(user)
    }

    function logout(){
        return auth.signOut().then(()=>{})
    }

    // function resetPassword(email) {
    //     return auth.sendPasswordResetEmail(email)
    // }

    // function updateEmail(email) {
    //     return currentUser.updateEmail(email)
    // }

    // function updatePassword(password) {
    //     return currentUser.updatePassword(password)
    // }

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            setCurrentUser(user)
            setLoading(false)
        })

        return unsubscribe
    }, [])

    const value = {
        currentUser,
        // signup,
        login,
        logout,
        // resetPassword,
        // updateEmail,
        // updatePassword
    }

    return (
        loading?<div className='app-loader'><img src="/images/loading.svg" alt="" /></div>:
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    )
};